/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState } from 'react'
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { AppBar, CircularProgress, Toolbar } from '@mui/material'
import Navigation from 'components/Navigation'
import { logout } from 'redux/auth/actions'
import jwtDecode from 'jwt-decode'
import { readOptionsManagementScopes, Scopes } from 'utils/authUtils'

import Colors from 'utils/Colors'
import history from 'utils/history'
import { getUserPermissionIcon } from 'utils/constants/user'
import { ExitToApp } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { postLogout } from 'services/apiKYE'
import styles from './styles'
import MenuAvatar from "../../components/MenuAvatar"
import { ROUTE_CONSTANTS } from "../../utils/constants/routeConstants"

const SignedInLayout = ({ component: Component, ...rest }) => {
  const classes = styles()
  const dispatch = useDispatch()
  const logoutInProgress = useRef(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const token = useSelector((state) => state.auth.access_token)
  const decodedToken = token ? jwtDecode(token) : { username: '', scopes: [] }
  const userName = decodedToken.username

  const handleLogout = async () => {
    if (logoutInProgress.current) return

    logoutInProgress.current = true
    setIsLoggingOut(true)

    try {
      await postLogout(token)
    } catch (error) {
      toast.error(
        error?.response?.data?.detail
        || error?.response?.data?.message
        || 'Não foi possível encerrar a sessão no servidor.',
      )
    } finally {
      dispatch(logout())
    }
  }

  const handleRestrictions = () => {
    history.push(ROUTE_CONSTANTS.RESTRICTED_OPTIONS)
    history.go(0)
  }

  const handleUserManagement = () => {
    history.push(ROUTE_CONSTANTS.USER_MANAGEMENT)
    history.go(0)
  }

  const menuOptions = [{
    action: handleLogout,
    text: 'Sair',
    icon: isLoggingOut ? <CircularProgress size={20} /> : <ExitToApp />,
    disabled: isLoggingOut,
  }]
    if (readOptionsManagementScopes.every(scope => decodedToken.scopes.includes(scope))) {
      menuOptions.unshift({
        action: handleRestrictions,
        icon: getUserPermissionIcon(Scopes.OPTIONS_MANAGEMENT),
        text: 'Opções Restritivas',
      })
  }

  if (decodedToken.scopes.includes(Scopes.USER_MANAGEMENT_LIST_USERS)) {
    menuOptions.unshift({
      action: handleUserManagement,
      icon: getUserPermissionIcon(Scopes.USER_MANAGEMENT_LIST_USERS),
      text: 'Gerenciamento de Usuários',
    })
  }

  const renderMainBar = () => (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: Colors.headerColor }}>
        <Toolbar>
          <div className={classes.titleContainer}>
            <img
              src="/assets/images/logos/client_logo.png"
              alt="Logo"
              className={classes.logo}
            />
            <img
              src="/assets/images/logos/toolbar_logo.svg"
              alt="Logo By Dimensa branco"
              className={classes.logoDimensa}
            />
            <h2>KYE</h2>
            <Navigation />
          </div>

          {process.env.REACT_APP_LOGIN_DISABLED === 'true' ? null : (
            <div className={classes.userContainer}>
              <MenuAvatar username={userName} options={menuOptions} />
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <div>
          {renderMainBar()}
          <Component {...matchProps} />
        </div>
      )}
    />
  )
}

export default SignedInLayout
